'use strict';

angular.module('userRequestArrivalControllers')

.controller('RequestArrivalWithEventIDController', ['$scope', '$state', '$stateParams', 'userRequestArrivalService', function ($scope, $state, $stateParams, userRequestArrivalService) {

    var eventId = $stateParams.eventId;

    // Get or create user request
    userRequestArrivalService.request.getOrCreateForArrivalEvent(eventId)
        .then(function (requestOrError) {

            if (requestOrError.ObjectClass === 'UserErrorMessage') {
                $scope.errorMessage = requestOrError;
            }
            else {
                $state.go('userAccessRequest.edit', { //'userAccessRequest_forArrivalEvent', {
                    userAccessRequestId: requestOrError.UserAccessRequestID
                });
            }
        });
}]);